<mat-form-field appearance="outline" class="w-100">
  <mat-label>Select a track</mat-label>
  <mat-select (selectionChange)="trackSelect($event)" [(ngModel)]="toTrack" disableOptionCentering>
    <mat-option *ngFor="let track of inventoryTracks" [value]="track">
      {{ track.name }}
    </mat-option>
  </mat-select>
</mat-form-field>
